import React from 'react'
import { CardFooter as ReactstrapCardFooter, CardFooterProps } from 'reactstrap'

export const CardFooter: React.FC<CardFooterProps> = props => {
  return <ReactstrapCardFooter {...props} />
}
